<template>
  <div class="container">
    <div class="top">
      <p class="total">
        共 <label>{{ total }}</label> 条记录
      </p>
      <div class="search">
        <el-input
          v-model="keyWords"
          placeholder="请输入要搜索的内容"
          @keyup.enter.native="toSearch"
          clearable
        ></el-input>
        <span class="search_img" @click="toSearch">
          <img src="../../assets/images/search_icon.png" />
        </span>
      </div>
    </div>
    <!-- 资讯列表 -->
    <div class="news-list">
      <ul>
        <li v-for="(item, index) in tableData" :key="index">
          <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
          <div class="news-right">
            <p class="title" @click="toDetail(item.sid)">
              <span class="line1" v-safe-html="item.title"></span>
            </p>
            <div class="news-ai" v-if="item.alDigest">
              <p><img src="../../assets/images/ainews2.png" alt="" /></p>
              <!-- <p class="news-ai-text">{{ item.alDigest }}<label>展开</label></p> -->
              <p class="news-ai-text" v-if="!item.open">
                <span v-safe-html="capitalize(item.alDigest)"></span>
                <label
                  class="digestLabel"
                  v-if="item.alDigest.length > 310"
                  @click="showDigest(index)"
                  >展开</label
                >
              </p>
              <p class="news-ai-text" v-if="item.open">
                <span v-safe-html="item.alDigest"></span>
                <label class="digestLabel" @click="closeDigest(index)"
                  >收起</label
                >
              </p>
            </div>
            <div class="news-bottom">
              <span>{{ item.author }}</span>
              <span></span>
              <span>{{ item.publishTime }}</span>
              <a class="btn" @click="removeCollect(index)">取消收藏</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="noData" v-if="total <= 0">
      <img src="../../assets/images/noData.png" />
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[10, 20, 30, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      hide-on-single-page
    >
    </el-pagination>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  name: "MyApply",
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 100,
      keyWords: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    toSearch() {
      this.pageNo = 1;
      this.getList();
    },
    getList() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        type: 4,
      };
      this.$http({
        url: "api/v1/usershare/list",
        method: "POST",
        data: postBody,
      }).then((res) => {
        this.total = res.total;
        this.tableData = res.rows;
      });
    },
    toDetail(sid) {
      this.$http({
        url: "api/v1/subject/brochure/sys/url?sid=" + sid,
        method: "get",
      }).then((res) => {
        window.open(baseurl.localUrl + res.data);
      });
    },
    // 摘要展开
    showDigest(index) {
      this.tableData[index].open = true;
      this.$forceUpdate();
    },
    closeDigest(index) {
      this.tableData[index].open = false;
      this.$forceUpdate();
    },
    removeCollect(index) {
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let postBody = {
          outSid: this.tableData[index].sid,
          type: 4,
        };
        this.$http({
          url: `api/v1/usershare/collect`,
          method: "POST",
          data: postBody,
        }).then((res) => {
          if (res.code == 200) {
            this.pageNo = 1;
            this.$message.success("取消收藏成功");
            this.getList();
          }
        });
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .top {
    display: flex;
    align-items: center;
    padding: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    .total {
      label {
        color: #2d8cf0;
      }
    }
    .search {
      display: flex;
      align-items: center;
      background: #fff;
      border: 1px solid #cccccc;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 0;
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-input__icon {
        line-height: 30px;
      }
      .el-input {
        width: 280px;
      }
      .search_img {
        width: 40px;
        height: 30px;
        background: #2d8cf0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .news-list {
    padding: 20px;
    font-size: 15px;
    li {
      border-bottom: 1px dashed #eee;
      padding: 20px 0;
      display: flex;
      .index {
        width: 50px;
      }
      .news-right {
        flex: 1;
        min-width: 0;
      }
      &:nth-of-type(1) {
        padding-top: 0;
      }
      &:last-of-type {
        border: none;
        padding-bottom: 0;
      }
      .title {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 17px;
        cursor: pointer;
        &:hover {
          background-image: linear-gradient(to right, #006eb3, #2d8cf0);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        img {
          margin-right: 10px;
        }
      }
      .news-ai {
        background: #f7f8fa;
        padding: 20px;
        margin-top: 15px;
        img {
          width: 80px;
        }
        .news-ai-text {
          color: #636870;
          line-height: 25px;
          .digestLabel {
            color: #2d8cf0;
            cursor: pointer;
            margin-left: 3px;
          }
        }
      }
      .news-bottom {
        margin-top: 15px;
        display: flex;
        align-items: center;
        span {
          margin-right: 20px;
          color: #636870;
          &:nth-of-type(2) {
            height: 10px;
            width: 1px;
            display: inline-block;
            background: #ddd;
          }
        }
        .checked {
          color: #2d8cf0;
        }
        a {
          margin-left: auto;
          border-radius: 4px;
          border: 1px solid #2d8cf0;
          color: #2d8cf0;
          font-size: 14px;
          padding: 5px 15px;
          display: inline-block;
        }
      }
    }
  }
}
</style>
